export const demo_SceneGraph_StackedImageGalleryTransparent_ImageBoxes_1 = [
  {
    id: "6bd831e7-91ba-4e73-9384-1cd6087981ff",
    label: "Aesgraph",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/demo/StackedGalleryTransparent/1.png",
    topLeft: {
      x: 319,
      y: 386.71875,
    },
    bottomRight: {
      x: 453,
      y: 485.71875,
    },
  },
  {
    id: "e23c920a-3a76-4fd8-91b0-eba7a3f50572",
    label: "Graphviz",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/demo/StackedGalleryTransparent/1.png",
    topLeft: {
      x: 179,
      y: 213.71875,
    },
    bottomRight: {
      x: 286,
      y: 322.71875,
    },
  },
  {
    id: "73b50511-8e1f-458b-8997-a5776f7e8562",
    label: "React Flow",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/demo/StackedGalleryTransparent/1.png",
    topLeft: {
      x: 291,
      y: 214.71875,
    },
    bottomRight: {
      x: 392,
      y: 319.71875,
    },
  },
  {
    id: "49d2a7cf-2341-4787-897a-5abf0496726e",
    label: "ForceGraph3d",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/demo/StackedGalleryTransparent/1.png",
    topLeft: {
      x: 403,
      y: 213.71875,
    },
    bottomRight: {
      x: 502,
      y: 323.71875,
    },
  },
  {
    id: "17880363-9a51-4c0d-af94-abe7802e2724",
    label: "Gephi",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/demo/StackedGalleryTransparent/1.png",
    topLeft: {
      x: 508,
      y: 215.71875,
    },
    bottomRight: {
      x: 610,
      y: 320.71875,
    },
  },
];

export const demo_SceneGraph_StackedImageGalleryTransparent_ImageBoxes_2 = [
  {
    id: "b76ffe2f-10bb-4737-ad08-03f98c30b362",
    label: "graph interaction, app bootstrapper",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/demo/StackedGalleryTransparent/2.png",
    topLeft: {
      x: 280,
      y: 103.71875,
    },
    bottomRight: {
      x: 444,
      y: 208.71875,
    },
  },
  {
    id: "fa7648d5-db5c-4e0a-96e0-0c3d5d9fc0f8",
    label: "graph analytics desktop app",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/demo/StackedGalleryTransparent/2.png",
    topLeft: {
      x: 525,
      y: 105.71875,
    },
    bottomRight: {
      x: 643,
      y: 179.71875,
    },
  },
  {
    id: "74a7e729-18b3-4668-9d4e-027482b5acb9",
    label: "graph model language and layout engine",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/demo/StackedGalleryTransparent/2.png",
    topLeft: {
      x: 127,
      y: 316.71875,
    },
    bottomRight: {
      x: 298,
      y: 407.71875,
    },
  },
  {
    id: "f87cceff-f400-43a6-95cb-5927df82946a",
    label: "3d force directed graph interaction library",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/demo/StackedGalleryTransparent/2.png",
    topLeft: {
      x: 381,
      y: 315.71875,
    },
    bottomRight: {
      x: 534,
      y: 403.71875,
    },
  },
];

export const demo_SceneGraph_StackedImageGalleryTransparent_ImageBoxes_3 = [
  {
    id: "d61503c0-1b9d-42d0-831a-0610149ad3b8",
    label: "web-based graph/spatial analytics app",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/demo/StackedGalleryTransparent/3.png",
    topLeft: {
      x: 89,
      y: 446.71875,
    },
    bottomRight: {
      x: 302,
      y: 505.71875,
    },
  },
  {
    id: "55045173-e2b3-4092-b258-ed252648a31f",
    label: "a unified information composition and exchange platform",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/demo/StackedGalleryTransparent/3.png",
    topLeft: {
      x: 87,
      y: 513.71875,
    },
    bottomRight: {
      x: 301,
      y: 572.71875,
    },
  },
  {
    id: "215e5050-70f5-45d6-86eb-3d66b47f3e6c",
    label: "an application bootstrapper",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/demo/StackedGalleryTransparent/3.png",
    topLeft: {
      x: 435,
      y: 447.71875,
    },
    bottomRight: {
      x: 639,
      y: 485.71875,
    },
  },
  {
    id: "2d56d59a-df1e-4e2e-aa06-07b5aec738cb",
    label: "ai output validity check machine",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/demo/StackedGalleryTransparent/3.png",
    topLeft: {
      x: 425,
      y: 485.71875,
    },
    bottomRight: {
      x: 766,
      y: 515.71875,
    },
  },
  {
    id: "8109a17a-d0a8-4122-bb9d-2c054f88f80d",
    label: "and more",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/demo/StackedGalleryTransparent/3.png",
    topLeft: {
      x: 427,
      y: 519.71875,
    },
    bottomRight: {
      x: 758,
      y: 551.71875,
    },
  },
  {
    id: "f536d219-afe6-4ded-b5d3-eeaac154b143",
    label: "Aesgraph",
    type: "ImageBox",
    description: "",
    imageUrl: "/images/demo/StackedGalleryTransparent/3.png",
    topLeft: {
      x: 13,
      y: 26.71875,
    },
    bottomRight: {
      x: 779,
      y: 481.71875,
    },
  },
];
